"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumType = exports.EnumDownload = void 0;
/**
 * 下载页面常量
 */
var EnumDownload;
(function (EnumDownload) {
    // 下载中心
    EnumDownload["DOWNLOAD_URL"] = "https://meeting.tencent.com/download-center.html";
    // 国外下载中心
    EnumDownload["VOOV_DOWNLOAD_URL"] = "https://www.voovmeeting.com/download-center.html";
    // 安卓下载
    EnumDownload["ANDROID_DOWNLOAD_URL"] = "https://meeting.tencent.com/download-android.html";
    // ios下载
    EnumDownload["IOS_DOWNLOAD_URL"] = "https://meeting.tencent.com/download-ios.html";
    // mac下载
    EnumDownload["MAC_DOWNLOAD_URL"] = "https://meeting.tencent.com/download-mac.html";
    // windows下载
    EnumDownload["WIN_DOWNLOAD_URL"] = "https://meeting.tencent.com/download-win.html";
    // linux下载
    EnumDownload["LINUX_DOWNLOAD_URL"] = "https://meeting.tencent.com/download-linux.html";
    // outlook下载
    EnumDownload["OUTLOOK__DOWNLOAD_URL"] = "https://meeting.tencent.com/download-outlook.html";
    // beta下载
    EnumDownload["BETA_DOWNLOAD_URL"] = "https://meeting.tencent.com/download-beta.html";
})(EnumDownload = exports.EnumDownload || (exports.EnumDownload = {}));
/**
 * type 需要下载的类型枚举
 */
var EnumType;
(function (EnumType) {
    EnumType[EnumType["android"] = 0] = "android";
    EnumType[EnumType["ios"] = 1] = "ios";
    EnumType[EnumType["win"] = 2] = "win";
    EnumType[EnumType["linux"] = 3] = "linux";
    EnumType[EnumType["beta"] = 4] = "beta";
    EnumType[EnumType["mac-apple"] = 5] = "mac-apple";
    EnumType[EnumType["mac-intel"] = 6] = "mac-intel";
    EnumType[EnumType["voov"] = 7] = "voov";
    EnumType[EnumType["center"] = 8] = "center";
})(EnumType = exports.EnumType || (exports.EnumType = {}));
//# sourceMappingURL=download.js.map